import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef } from "react";
import {
  Wallet,
  setRecivedCashDialog,
} from "../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { HiOutlineBanknotes, HiOutlineReceiptRefund } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const ReceiveCashForm = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user.form);
  const _Wallet = useSelector((state) => state.wallet);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody
  );
  const { control, handleSubmit } = useForm({
    defaultValues: {},
  });

  const onSubmit = (data) => {
    data.from_user_id = user.id;
    dispatch(Wallet.receiveCashPos(data, transactionsSearchBody)).then((x) => {
      dispatch(setRecivedCashDialog());
    });
  };

  const handlDialog = () => {
    dispatch(setRecivedCashDialog());
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });

  return (
    <FormDialog
      open={_Wallet.recivedCashDialog}
      onClose={handlDialog}
      icon={<HiOutlineReceiptRefund />}
      title={
        user.is_representative ? "تسديد الديون للمندوب" : "تسديد الديون للنقطة"
      }
      subtitle="أدخل المبلغ المسدد ثم احفظ"
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات التسديد">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ReceiveCashForm;
